// frontend/src/views/LoginView.jsx

import React from 'react';
import { GoogleLogin } from '@react-oauth/google';
import { useAuth } from '../context/AuthContext';
import { Printer } from 'lucide-react'; // <--- Import Icon

function LoginView() {
    const { handleLoginSuccess } = useAuth();

    return (
        <div style={{ 
            height: '100vh', display: 'flex', flexDirection: 'column', 
            alignItems: 'center', justifyContent: 'center', background: '#f1f5f9' 
        }}>
            <div className="card" style={{ textAlign: 'center', padding: '40px', maxWidth: '400px' }}>
                
                {/* ?? FIXED: Replaced Emoji with Icon */}
                <div style={{ marginBottom: '20px', display: 'inline-flex', padding: '15px', borderRadius: '50%', background: '#e0f2f1' }}>
                    <Printer size={64} color="#0d9488" />
                </div>

                <h1 style={{ color: '#0d9488', marginBottom: '10px' }}>PolyUnity Farm</h1>
                <p style={{ marginBottom: '30px', color: '#64748b' }}>
                    Please sign in to access fleet management and maintenance logs.
                </p>
                
                <div style={{ display: 'flex', justifyContent: 'center' }}>
                    <GoogleLogin
                        onSuccess={handleLoginSuccess}
                        onError={() => alert('Login Failed')}
                        useOneTap
                        hosted_domain="polyunity.com"
                    />
                </div>
                
                <p style={{ marginTop: '20px', fontSize: '0.8rem', color: '#94a3b8' }}>
                    Restricted to @polyunity.com accounts.
                </p>
            </div>
        </div>
    );
}

export default LoginView;